<div mat-dialog-content class="border-b border-black/[.12]">
  <p class="py-4">Are you sure you want to duplicate quote #{{ data.quoteId }}?</p>
</div>
<div mat-dialog-actions class="flex justify-end">
  <button mat-flat-button (click)="onCancel()" [disabled]="isDuplicating()">NO</button>
  <button mat-flat-button (click)="onConfirm()" [disabled]="isDuplicating()">YES</button>
</div>
